export default "__VITE_ASSET__841af27c__"